import React from "react";
import { Controller } from "react-hook-form";
import {
  TextField,
  FormControl,
  FormHelperText,
  Autocomplete,
} from "@mui/material";

const norm = (v) =>
  v === null || v === undefined || v === "" ? "" : String(v);

const SearchableSelectInput = ({
  name,
  control,
  label,
  options,
  defaultValue = "",
  rules = {},
  disabled = false,
}) => {
  return (
    <FormControl fullWidth variant="outlined">
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          <>
            <Autocomplete
              disabled={disabled}
              options={options}
              getOptionLabel={(option) => option.label || ""}
              value={
                options.find(
                  (option) => norm(option.value) === norm(field.value)
                ) || null
              }
              onChange={(_, data) =>
                field.onChange(data != null ? norm(data.value) : "")
              }
              isOptionEqualToValue={(option, value) =>
                value != null &&
                norm(option.value) === norm(value.value)
              }
              noOptionsText="No se encontraron resultados"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  variant="outlined"
                  // error={!!error}
                  // helperText={error ? error.message : null}
                />
              )}
            />
            <FormHelperText>{error ? error.message : null}</FormHelperText>
          </>
        )}
      />
    </FormControl>
  );
};

export default SearchableSelectInput;
